import { WFRoute } from "@xatom/core";

export const routes = () => {
  //lazy loading homePagesList when needed
  new WFRoute("/").execute(() => {
    import("../modules")
      .then(({ homePagesList }) => {
        homePagesList();
      })
      .catch(console.log);
  });
  //lazy loading pageCopyUrls and pageChaptersList when needed
  new WFRoute("/site-sections/:slug").execute(
    ({ slug }) => {
      Promise.all([
        import("../modules/pageCopyUrls"),
        import("../modules/pageChaptersList"),
      ])
        .then(
          ([{ pageCopyUrls }, { pageChaptersList }]) => {
            pageCopyUrls(slug);
            pageChaptersList(slug);
          }
        )
        .catch(console.log);
    }
  );

  //lazy loading pageCopyUrls, chapterContentItems and pageTemplateSidebarMenu when needed
  new WFRoute("/pages/:slug").execute(({ slug }) => {
    Promise.all([
      import("../modules/pageCopyUrls"),
      import("../modules/chapterContentItems"),
      import("../modules/pageTemplateSidebarMenu"),
    ])
      .then(
        ([
          { pageCopyUrls },
          { chapterContentItems },
          { pageTemplateSidebarMenu },
        ]) => {
          pageCopyUrls(slug);
          chapterContentItems(slug);
          pageTemplateSidebarMenu(slug);
        }
      )
      .catch(console.log);
  });
};
